import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=232c9df3&"
import script from "./strategy.vue?vue&type=script&lang=js&"
export * from "./strategy.vue?vue&type=script&lang=js&"
import style0 from "./strategy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports